module.exports = __webpack_public_path__ + "img/logo.a066750b.png";